/**
 * Gratis gave ved køb over et beløb — lægger gaven i kurven og tager den ud
 * igen (Andreas 7/10-2026; konfigurationen skrives af snippets/gave-ved-koeb.liquid
 * og findes KUN når appen har bekræftet Shopify-rabatten).
 *
 * Regler:
 *  - Gaven lægges i, når kurvens subtotal UDEN gaven er mindst beløbet
 *    (omregnet til kundens valuta med Shopify.currency.rate), med den skjulte
 *    note "_Gratis gave" så den kan kendes igen — "Antal gaver" stk. på én
 *    linje. Retter kunden antallet på gave-linjen, sættes det tilbage.
 *  - Bagefter tjekkes det i kurven, at Shopify faktisk gjorde den gratis. Er
 *    den ikke gratis (fx under grænsen efter afrunding, eller kunden er kommet
 *    under beløbet), tages DEN linje ud igen — kunden betaler aldrig for en gave.
 *  - Fjerner kunden selv gaven, lægges den ikke i igen i denne session.
 *  - Har kunden selv varen i kurven (uden noten), røres intet.
 *  - Kører ved sidevisning og efter hver kurv-ændring (temaets events
 *    on:cart:add / on:line-item:change), lidt forsinket så produkt-formularens
 *    egen skuffe-tegning er færdig først.
 */
(() => {
  const dataEl = document.getElementById('gave-ved-koeb-data');
  if (!dataEl) return;
  let gaver;
  try {
    gaver = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!Array.isArray(gaver) || gaver.length === 0) return;

  const ROD = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const KURS = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
  const NOTE = '_Gratis gave';
  const FORSINKELSE_MS = 900;

  const gem = (noegle, vaerdi) => {
    try {
      if (vaerdi === undefined) return sessionStorage.getItem(noegle);
      if (vaerdi === null) sessionStorage.removeItem(noegle);
      else sessionStorage.setItem(noegle, vaerdi);
    } catch (e) {
      // Privat vindue o.l.: uden hukommelse virker reglerne stadig, bare uden "fravalgt".
    }
    return null;
  };

  const hentKurv = async () => {
    const svar = await fetch(`${ROD}cart.js`, { headers: { Accept: 'application/json' } });
    if (!svar.ok) throw new Error(`cart.js ${svar.status}`);
    return svar.json();
  };

  const send = async (sti, krop) => {
    const svar = await fetch(`${ROD}${sti}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(krop)
    });
    if (!svar.ok) throw new Error(`${sti} ${svar.status}`);
    return svar.json();
  };

  const voresLinje = (kurv, variantId) =>
    kurv.items.find((l) => l.variant_id === variantId && l.properties && l.properties[NOTE]);

  /** Tegn kurv-skuffe, kurv-ikon og (på kurv-siden) kurven igen. */
  const tegnIgen = async () => {
    const skuffe = document.querySelector('cart-drawer');
    if (skuffe && typeof skuffe.refresh === 'function') await skuffe.refresh(true);
    const kurvSide = document.querySelector('.cc-main-cart cart-items');
    if (kurvSide && typeof kurvSide.refresh === 'function') kurvSide.refresh();
  };

  let koerer = false;
  let igen = false;

  const tjek = async () => {
    if (koerer) {
      igen = true;
      return;
    }
    koerer = true;
    try {
      let kurv = await hentKurv();
      let aendret = false;

      for (const gave of gaver) {
        const n = `gave-ved-koeb:${gave.variantId}`;
        const vores = voresLinje(kurv, gave.variantId);
        const graense = Math.round(gave.minOere * KURS);
        const antal = Number(gave.antal) > 0 ? Number(gave.antal) : 1;

        // En tom kurv nulstiller kundens fravalg.
        if (kurv.item_count === 0) {
          gem(`${n}:fravalgt`, null);
          gem(`${n}:tilfoejet`, null);
          continue;
        }

        if (vores) {
          gem(`${n}:tilfoejet`, '1');
          if (vores.quantity !== antal) {
            // Kunden har rettet antallet på gave-linjen — tilbage til gavens antal.
            kurv = await send('cart/change.js', { id: vores.key, quantity: antal });
            aendret = true;
            const rettet = voresLinje(kurv, gave.variantId);
            if (!rettet) continue;
            if (rettet.final_line_price <= 0) continue;
          }
          const linje = voresLinje(kurv, gave.variantId);
          if (linje && linje.final_line_price > 0) {
            // Ikke (længere) gratis → ud igen. Husk subtotalen, så vi ikke
            // lægger den i igen før kurven ændrer sig.
            gem(`${n}:tilfoejet`, null);
            kurv = await send('cart/change.js', { id: linje.key, quantity: 0 });
            gem(`${n}:ikkeGratisVed`, String(kurv.items_subtotal_price));
            aendret = true;
          }
          continue;
        }

        if (gem(`${n}:tilfoejet`) === '1') {
          // Vi lagde den i, og nu er den væk uden at vi tog den ud: kunden fjernede den.
          gem(`${n}:tilfoejet`, null);
          gem(`${n}:fravalgt`, '1');
          continue;
        }
        if (gem(`${n}:fravalgt`) === '1') continue;
        if (kurv.items.some((l) => l.variant_id === gave.variantId)) continue;
        if (kurv.items_subtotal_price < graense) continue;
        if (gem(`${n}:ikkeGratisVed`) === String(kurv.items_subtotal_price)) continue;

        await send('cart/add.js', {
          items: [{ id: gave.variantId, quantity: antal, properties: { [NOTE]: '1' } }]
        });
        kurv = await hentKurv();
        const ny = voresLinje(kurv, gave.variantId);
        if (ny && ny.final_line_price > 0) {
          // Shopify gav ikke rabatten — tag den ud igen med det samme.
          kurv = await send('cart/change.js', { id: ny.key, quantity: 0 });
          gem(`${n}:ikkeGratisVed`, String(kurv.items_subtotal_price));
        } else if (ny) {
          gem(`${n}:tilfoejet`, '1');
        }
        aendret = true;
      }

      if (aendret) await tegnIgen();
    } catch (e) {
      console.log('[gave-ved-koeb]', e); // eslint-disable-line
    } finally {
      koerer = false;
      if (igen) {
        igen = false;
        setTimeout(tjek, 0);
      }
    }
  };

  let timer = null;
  const planlaeg = () => {
    clearTimeout(timer);
    timer = setTimeout(tjek, FORSINKELSE_MS);
  };

  document.addEventListener('on:cart:add', planlaeg);
  document.addEventListener('on:line-item:change', planlaeg);
  // Ved sidevisning kun når kurven ikke er tom (ellers et unødigt kald pr. side).
  if (Number(dataEl.dataset.antal) > 0) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', planlaeg);
    } else {
      planlaeg();
    }
  }
})();
